import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:opacity-80 transition-opacity"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-play-circle-fill text-3xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
            </div>
            <span className="text-xl font-bold font-heading whitespace-nowrap">菠萝视频</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => {
              const isActive = location.pathname === `/category/${cat.slug}`;
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                  }`}
                >
                  <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5">
                    <i className={cat.icon}></i>
                  </span>
                  {cat.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              关于我们
            </Link>
            <a
              href="#"
              className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即观看
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-200/70 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-2">
            <div className="flex flex-wrap gap-1.5 mb-3">
              {categories.map((cat) => {
                const isActive = location.pathname === `/category/${cat.slug}`;
                return (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap ${
                      isActive
                        ? 'bg-primary-500 text-background-50'
                        : 'text-foreground-700 bg-background-100 hover:bg-background-200'
                    }`}
                  >
                    <span className="w-3.5 h-3.5 inline-flex items-center justify-center mr-1">
                      <i className={cat.icon}></i>
                    </span>
                    {cat.name}
                  </Link>
                );
              })}
            </div>
            <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
              <Link
                to="/about"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors"
              >
                关于我们
              </Link>
              <a
                href="#"
                className="px-4 py-1.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即观看
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}